import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const WhatsAppButton = styled.button`
  width: 100%;
  padding: 10px 24px;
  background-color: #FFFFFF;
  border: 1px solid ${props => props.theme.palette.greyscale.grey200};
  border-radius: 5px;
  color: ${props => props.theme.palette.greyscale.grey500};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover:not(:disabled) {
    background-color: ${props => props.theme.palette.greyscale.grey50};
    border-color: ${props => props.theme.palette.greyscale.grey300};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
    color: #25D366; /* Mantido específico do WhatsApp */
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}){
    font-size: 12px;
    padding: 8px 18px;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  @media(min-width: ${props => props.theme.breakpoints.desktopXl}){
    font-size: 15px;
    padding: 10px 24px;
  }
`;

export const FlowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;